/**
 *  CircleAlLogoComponent provides the basic AL logo component.
 *
 *  @author Gisler Garces <ggarces@alertlogic.com>
 *
 *  @copyright Alert Logic, Inc 2017
 *
 * Sample about how to use it
 *    <circle-al-logo></circle-al-logo>
 *
 */
import { Component } from '@angular/core';

@Component({
    selector: 'circle-al-logo',
    templateUrl: './circle-al-logo.component.html',
    styleUrls: ['./circle-al-logo.component.scss']
})
export class CircleAlLogoComponent { }
